import { useContext } from "react"
import ConfirmationModal from "../../../../features/reporting/ConfirmationModal"
import { ReportingContext } from "../../../../wrappers/ReportingContext"

const UnsavedChangesModal = () => {
    const {
        hasUnsavedChanges,
        setHasUnsavedChanges,
        navigateAndDiscard
    } = useContext(ReportingContext)

    return (
        <ConfirmationModal
            display={hasUnsavedChanges}
            title={'Unsaved Changes'}
            confirmAction={navigateAndDiscard}
            confirmText={`Discard Changes`}
            denyAction={() => setHasUnsavedChanges(false)}
            denyText={`Cancel`}
        >
            <p>There are unsaved changes. Do you wish to discard these changes?</p>
        </ConfirmationModal>
    )
}

export default UnsavedChangesModal